import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
export function UrgencyBlock() {
  return <section className="py-6 md:py-12 px-4 bg-[#2B2724] text-white" data-id="element-307">
      <div className="max-w-3xl mx-auto" data-id="element-308">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white/5 backdrop-blur-sm rounded-xl border border-white/10 p-4 md:p-5" data-id="element-309">
          {/* Top row: offer + countdown */}
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-310">
            <div className="text-center sm:text-left" data-id="element-311">
              <span className="inline-block bg-[#C2613A] px-2.5 py-0.5 rounded-full text-[10px] md:text-xs font-semibold mb-1" data-id="element-312">
                Oferta en vivo
              </span>
              <p className="text-base md:text-xl font-bold leading-tight" data-id="element-313">
                +$10.000 DESPUÉS
              </p>
              <p className="text-[10px] md:text-xs text-white/70" data-id="element-314">
                LANZAMIENTO TERMINA EN · Y no vuelve a bajar
              </p>
            </div>
            <CountdownTimer compact data-id="element-315" />
          </div>

          {/* Cupos bar */}
          <div className="mt-3 pt-3 border-t border-white/10" data-id="element-316">
            <div className="flex items-center justify-between mb-1.5" data-id="element-317">
              <span className="text-[10px] md:text-xs font-semibold" data-id="element-318">
                Cupos restantes
              </span>
              <span className="text-[10px] md:text-xs font-bold text-[#C2613A]" data-id="element-319">
                68% TOMADOS
              </span>
            </div>
            <div className="w-full bg-white/20 rounded-full h-2 overflow-hidden" data-id="element-320">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: '68%'
            }} viewport={{
              once: true
            }} transition={{
              duration: 1,
              delay: 0.3
            }} className="bg-[#C2613A] h-full rounded-full" data-id="element-321" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}